import { ROUND, ROUNDDOWN, ROUNDUP, XIF } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib, _getVentilatorSingleFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
// import { terLibVentilatoriProbni } from './ter-params-lib';
import { MINUS, SPACE } from '../utils/frfr-string-consts';
import { _getFromLibMaterijalLimSingleParam, _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';
import { js_utils } from '../utils/frfr-js-utils';
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';
import { terUtilsNumberRoundUp, terUtils_get_naziv_materijala_by_ident } from './ter-utils';
import { terProtobompUtils_make_protobomp_manifest_terkk_latest, terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL, terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL } from './ter-protobomp-utils';
import { protobomp_manipulator } from '../utils/frfr-protobomp-utils';
import { _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje } from './ter-derivat-lib-terkk-uni-dimenzije';


/*
TODO

*/


const TIP_1D = "1D";
const TIP_4D = "4D";
const TIP_6D = "6D";
const ZAZOR_PANELA = 1;


//
export const derDraftel_terkk_ppv_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // ...draftel_codecs_pack_terkk$_bundle_ppv.default_preset_state(),
    tipkomore: virtel_k.tipkomore,
    vrstaprofila: virtel_m.vrstaprofila, // NOVO 2023-11-27 Da bi moglo da se izracuna visina kada je ventilator na nosacu
    msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih,
    msirinaunutrasnjaizmedjuosnovnih: virtel_m.msirinaunutrasnjaizmedjuosnovnih,
    mvisinaunutrasnjaizmedjupregradnih: virtel_m.mvisinaunutrasnjaizmedjupregradnih,
    mvisinaunutrasnjaizmedjuosnovnih: virtel_m.mvisinaunutrasnjaizmedjuosnovnih,
    /*
    // OLD
    vrstaprofila: virtel_m.vrstaprofila,
    msirinaunutrasnja: virtel_m.msirinaunutrasnja,
    mvisinaunutrasnja: virtel_m.mvisinaunutrasnja,
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
    mvisinaspoljasnja: virtel_m.mvisinaspoljasnja,
    */
  };
  return pods_input_inherited;
};


//
export const derDraftel_terkk_ppvnosacv_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    // ...draftel_codecs_pack_terkk$_bundle_nosacventilatora.default_pods_input_state(),
    tipkomore: virtel_k.tipkomore,
    vrstaprofila: virtel_m.vrstaprofila,
    duzinamodula: virtel_m.duzinamodula,
    // msirinaunutrasnjaizmedjupregradnih: virtel_m.msirinaunutrasnjaizmedjupregradnih,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    msirinaspoljasnja: virtel_m.msirinaspoljasnja,
  };
  return pods_input_inherited;
};


// TODO cparams_combined uzeti materijale
export const _derivat_terkk_ppv_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    let _cpci = {};
    _cpci = cparams_combined.terkk_materijal_ident;
    //
    let tipmetalalima = "pocinkovani";
    let termaterijal = null;
    if (pods_input.tipkomore === "HYGIENE:pro") {
      tipmetalalima = "prohrom";
      termaterijal = _cpci.ppv_materijal_lim_prohrom;
    } else {
      tipmetalalima = "pocinkovani";
      termaterijal = _cpci.ppv_materijal_lim_pocinkovani;
    }
    //
    return {
      tipmetalalima,
      termaterijal,
    };
  } else {
    // OLD v1 kod starjih smartboma gde nije bilo cparams
    //
    // _default_materijali_v1 sluze da zadrze kompatibilnost sa starim sastavnicama pre cparams
    const _default_materijali_v1 = {
      "ppv_materijal_lim_pocinkovani": "LB00000J", // LIM POCINKOVANI 1.50 // NOVO
      "ppv_materijal_lim_prohrom": "LC00000J", // LIM PROHROM 1.50 // NOVO
    };
    //
    let tipmetalalima = "pocinkovani";
    let termaterijal = null;
    if (pods_input.tipkomore === "HYGIENE:pro") {
      tipmetalalima = "prohrom";
      termaterijal = _default_materijali_v1.ppv_materijal_lim_prohrom;
    } else {
      tipmetalalima = "pocinkovani";
      termaterijal = _default_materijali_v1.ppv_materijal_lim_pocinkovani;
    }
    //
    return {
      tipmetalalima,
      termaterijal,
    };
  }
};


//
export const _derivat_terkk_ppvnosacv_izracunaj_materijale = (pods_input, cparams_combined) => {
  //
  const tipkomore = pods_input.tipkomore;
  //
  let _cpci = {};
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
    // By cparmas
    _cpci = cparams_combined.terkk_materijal_ident;
  }
  //
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  let ppvnosacv_materijal_lim = null;
  // let ppvnosacv_materijal_lim_pocinkovani = null;
  // let ppvnosacv_materijal_lim_prohrom= null;
  // let ppvnosacv_materijal_lim_maska_unp_prohrom = null;
  //
  if (tipmetalalima === "pocinkovani") {
    ppvnosacv_materijal_lim = _cpci.ppvnosacv_materijal_lim_pocinkovani;
  }
  if (tipmetalalima === "prohrom") {
    ppvnosacv_materijal_lim = _cpci.ppvnosacv_materijal_lim_prohrom;
  }
  //
  const ppvnosacv_materijal_lim_maska_unp = _cpci.ppvnosacv_materijal_lim_maska_unp_prohrom;
  const ppvnosacv_materijal_profil_unp_bezdimenzioni = _cpci.ppvnosacv_materijal_profil_unp_bezdimenzioni;
  //
  return {
    tipmetalalima,
    ppvnosacv_materijal_lim,
    ppvnosacv_materijal_lim_maska_unp,
    ppvnosacv_materijal_profil_unp_bezdimenzioni,
  };
};


//
export const derivatPoluproizvod_ppv_naziv = (ppv_tip, ppv_b, ppv_h) => {
  //
  // DL 2023-09-12: dobijeni broj zaokruziti na jednu decimalu ROUNDOWN. Bitno je u prikazu i u nazivima za nalepnice da ne bude vise od 1 decimale a pri racunanjima da se koriste prave mere bez zaokruzivanja.
  return 'Pregradni panel ventilatora ' + ppv_tip + SPACE + ROUNDDOWN(ppv_b, 1) + 'x' + ROUNDDOWN(ppv_h, 1); // DL: 2023-09-05
};

//
export const derivatPoluproizvod_ppv_sekcija_naziv = (ppv_tip, ppv_oznaka, sirina, visina) => {
  //
  console.log('+++ derivatPoluproizvod_ppv_sekcija_naziv');
  console.log('ppv_tip, ppv_oznaka, sirina, visina');
  console.log(ppv_tip);
  console.log(ppv_oznaka);
  console.log(sirina);
  console.log(visina);
  console.log('typeof sirina', typeof sirina);
  console.log('typeof visina', typeof visina);
  console.log('test ROUNDDOWN(sirina, 1)', ROUNDDOWN(sirina, 1));
  console.log('test ROUNDDOWN(visina, 1)', ROUNDDOWN(visina, 1));
  // return 'Pregradni panel ventilatora ' + ppv_tip + SPACE + ppv_oznaka + SPACE + ROUNDDOWN(sirina, 1) + 'x' + ROUNDDOWN(visina, 1); // DL: 2023-09-05
  const naziv = 'Pregradni panel ventilatora ' + ppv_tip + SPACE + ppv_oznaka + SPACE + ROUNDDOWN(sirina, 1) + 'x' + ROUNDDOWN(visina, 1); // DL: 2023-09-05
  console.log('izracunati naziv', naziv);
  return naziv;
};

//
export const derivatPoluproizvod_ppv_ojacanje_naziv = (_v_ili_h, duzina) => {
  //
  return 'Pregradni panel ventilatora Ojacanje ' + _v_ili_h + SPACE + duzina; // DL: 2023-09-05
};

//
export const derivatPoluproizvod_ppv_poklopac_naziv = (ppv_oznaka, sirina, visina) => {
  //
  return 'Pregradni panel ventilatora POKLOPCIC ' + ppv_oznaka + SPACE + ROUNDDOWN(sirina, 1) + 'x' + ROUNDDOWN(visina, 1); // predlog
};


//
/*
const _novo_ventilatorParamsGet = (key) => {
  let params = {};
  if (terLibVentilatoriProbni && terLibVentilatoriProbni[key] && terLibVentilatoriProbni[key].Rastojanje_izmedju_otvora_el_veze_o1) {
    params = {
      ...terLibVentilatoriProbni[key]
    }
  }
  return params;
};
*/


// izracunavanje sirina i visine na osnovu pods_input
export const _derivat_ppv_izracunaj_sirinu_i_visinu = (msirinaunutrasnjaizmedjupregradnih,
  msirinaunutrasnjaizmedjuosnovnih,
  mvisinaunutrasnjaizmedjupregradnih,
  mvisinaunutrasnjaizmedjuosnovnih,
  ppv_isnapregradnom) => {
  let ppv_b = 0; // sirina ppv-a
  let ppv_h = 0; // visina ppv-a
  if (ppv_isnapregradnom === "DA") {
    // IF(AND(Profil=70;Na pregradnom=True);UnutrasnjaSirinaIzSpoljasnje-Zazor panela)
    // ppv_b = msirinaunutrasnja - (2 * ZAZOR_PANELA);
    ppv_b = msirinaunutrasnjaizmedjupregradnih - (2 * ZAZOR_PANELA);
    ppv_h = mvisinaunutrasnjaizmedjupregradnih - (2 * ZAZOR_PANELA);
  }
  if (ppv_isnapregradnom === "NE") {
    // "IF(AND(Profil=70;Na pregradnom=False);UnutrasnjaSirinaIzSpoljasnje-Zazor panela-30)
    // ppv_b = msirinaunutrasnja - (2 * ZAZOR_PANELA) - 30;
    ppv_b = msirinaunutrasnjaizmedjuosnovnih - (2 * ZAZOR_PANELA);
    ppv_h = mvisinaunutrasnjaizmedjuosnovnih - (2 * ZAZOR_PANELA);
  }
  //
  return {
    ppv_b,
    ppv_h
  };
};


// 1) kad se izabere ventilator
//
export const _ppv_servisni_prekidaci_za_ventilatore_lib = {
  "3LD20640TB53": {
    "Ident": "3LD20640TB53",
    // "Naziv": "SERVISNI PREKIDAC 16 A (do 7,5 Kw)",
    "Naziv": "EMERG. STOP SWITCH 3-POLE IU=16, P/AC-23A AT 400V=7.5KW 1 N-TERMINAL + 1 PE IP65",
  },
  "3LD21640TB53": {
    "Ident": "3LD21640TB53",
    // "Naziv": "SERVISNI PREKIDAC 25 A (do 9,5 Kw)",
    "Naziv": "EMERG. STOP SWITCH 3-POLE IU=25, P/AC-23A AT 400V=9.5KW 1 N-TERMINAL + 1 PE IP65",
  },
  "3LD22640TB53": {
    "Ident": "3LD22640TB53",
    // "Naziv": "SERVISNI PREKIDAC 32 A (do 10 Kw)",
    "Naziv": "EMERG. STOP SWITCH 3-POLE IU=32, P/AC-23A AT 400V=11.5KW 1 N-TERMINAL+1 PE IP65",
  },
  "3LD25650TB53": {
    "Ident": "3LD25650TB53",
    // "Naziv": "SERVISNI PREKIDAC 63 A (do 22 Kw)",
    "Naziv": "EMERG. STOP SWITCH 3-POLE IU=63, P/AC-23A AT 400V=22KW 1 N-TERMINAL+1 PE IP65",
  },
  "3LD27660TB53": {
    "Ident": "3LD27660TB53",
    // "Naziv": "SERVISNI PREKIDAC 100 A (od 30kW do 37kW)",
    "Naziv": "EMGNCY MAIN CNTRL SWITCH 3-POLE IU=100, P/AC-23A AT 400V=37KW 1 N + 1 P , IP 65",
  },
};
//
export const _ppv_amortizeri_za_ventilatore_lib = {
  "B030000200000004": {
    "Ident": "B030000200000004",
    "Naziv": "VENTILATORI OPREMA AMORTIZER GUMENI NOVOTECH 30X30 M8",
  },
  "B030000200000005": {
    "Ident": "B030000200000005",
    "Naziv": "VENTILATORI OPREMA AMORTIZER GUMENI NOVOTECH 40X30 M8",
  },
  "B030000200000009": {
    "Ident": "B030000200000009",
    "Naziv": "VENTILATORI OPREMA AMORTIZER GUMENI NOVOTECH 40X40 M8",
  },
  "B030000200000007": {
    "Ident": "B030000200000007",
    "Naziv": "VENTILATORI OPREMA AMORTIZER GUMENI NOVOTECH 50X50 M10",
  },
  "B030000200000008": {
    "Ident": "B030000200000008",
    "Naziv": "VENTILATORI OPREMA AMORTIZER GUMENI NOVOTECH 75X50 M12",
  },
};
//
const _novo_izracunaj_servisni_prekidac = (Snaga_motora) => {
  /*
  Servisni prekidači za ventilatore #219
  Potrebno je da dodamo u sastavljaču i servisne prekidače za ventilatore.

  Servisni prekidači se u sastavnici dodaju kao materijal imamo 4 identa koje je potredno na osnovu jačine ventilatora dodati u sastavnicu. Količina je 1 po ventilatoru.

  Ident	Naziv	Snaga_motora
  3LD20640TB53	SERVISNI PREKIDAC 16 A (do 7,5 Kw)	<=7.5Kw
  3LD21640TB53	SERVISNI PREKIDAC 25 A (do 9,5 Kw)	>7.5Kw AND <=9.5Kw
  3LD22640TB53	SERVISNI PREKIDAC 32 A (do 10 Kw)	>9.5Kw AND <=10Kw
  3LD25650TB53	SERVISNI PREKIDAC 63 A (do 22 Kw)	>10Kw AND <=22Kw
  3LD27660TB53	SERVISNI PREKIDAC 100 A (od 30kW do 37kW)	>22Kw AND <=37Kw

  Pored toga što dodajemo u sastavnici komore, treba da se prikazuje i na formi za PPV i da bude omogućen custom unos identa , naziva i količine. Dakle da se u ppv formi automatski bira prekidac ali i da moze da se izmeni kao custom varijanta.
  */
  //
  let ppv_servisni_prekidac_ident = null;
  let ppv_servisni_prekidac_naziv = null;
  if (Snaga_motora > 0) {
    if (Snaga_motora <= 37) {
      ppv_servisni_prekidac_ident = "3LD27660TB53";
    }
    if (Snaga_motora <= 22) {
      ppv_servisni_prekidac_ident = "3LD25650TB53";
    }
    if (Snaga_motora <= 10) {
      ppv_servisni_prekidac_ident = "3LD22640TB53";
    }
    if (Snaga_motora <= 9.5) {
      ppv_servisni_prekidac_ident = "3LD21640TB53";
    }
    if (Snaga_motora <= 7.5) {
      // 3LD20640TB53	SERVISNI PREKIDAC 16 A (do 7,5 Kw)	<=7.5Kw
      ppv_servisni_prekidac_ident = "3LD20640TB53";
    }
  }
  if (ppv_servisni_prekidac_ident && _ppv_servisni_prekidaci_za_ventilatore_lib[ppv_servisni_prekidac_ident]) {
    ppv_servisni_prekidac_naziv = _ppv_servisni_prekidaci_za_ventilatore_lib[ppv_servisni_prekidac_ident].Naziv;
  }
  //
  const ppv_kontaktor_ident = "3LD92005C";
  const ppv_kontaktor_naziv = "AUXIL. SWITCH 1NO+1NC (ACCESSORY FOR SWITCH 3LD2) -NEW DESIGN-FOR FLOOR MOUNTING";
  //
  return {
    ppv_servisni_prekidac_ident,
    ppv_servisni_prekidac_naziv,
    ppv_kontaktor_ident,
    ppv_kontaktor_naziv,
  }
};
//
const _novo_izracunaj_amortizer = (Amortizeri, Broj_Amortizera) => {
  /*

  */
  //
  let ppv_amortizer_ident = null;
  let ppv_amortizer_naziv = null;
  if (Amortizeri === "30x30") {
    ppv_amortizer_ident = "B030000200000004";
  }
  if (Amortizeri === "40x30") {
    ppv_amortizer_ident = "B030000200000005";
  }
  if (Amortizeri === "40x40") {
    ppv_amortizer_ident = "B030000200000009";
  }
  if (Amortizeri === "50x50") {
    ppv_amortizer_ident = "B030000200000007";
  }
  if (Amortizeri === "75x50") {
    ppv_amortizer_ident = "B030000200000008";
  }
  if (ppv_amortizer_ident && _ppv_amortizeri_za_ventilatore_lib[ppv_amortizer_ident]) {
    ppv_amortizer_naziv = _ppv_amortizeri_za_ventilatore_lib[ppv_amortizer_ident].Naziv;
  }
  //
  return {
    ppv_amortizer_ident,
    ppv_amortizer_naziv,
  }
};
//
export const _derivat_ppv_izracunaj_pomocu_ventilatora_materijale = (ppv_ventilator_ident) => {
  // const ventilator_params = _novo_ventilatorParamsGet(ppv_ventilator_ident);
  const ventilator_params = _getVentilatorSingleFromLib(ppv_ventilator_ident);
  let params = {
    //
    ppv_servisni_prekidac_ident: null,
    ppv_servisni_prekidac_naziv: null,
    ppv_kontaktor_ident: null,
    ppv_kontaktor_naziv: null,
    ppv_amortizer_ident: null,
    ppv_amortizer_naziv: null,
    //
    ppv_vent_brojamortizera: "",
    ppv_vent_amortizeri: "",
  };
  //
  params.ppv_vent_brojamortizera = ventilator_params.Broj_Amortizera;
  params.ppv_vent_amortizeri = ventilator_params.Amortizeri;
  //
  const Snaga_motora = Number.parseFloat(ventilator_params.Snaga_motora);
  const _temp_servisni_prekidac = _novo_izracunaj_servisni_prekidac(Snaga_motora);
  if (Snaga_motora > 0) {
    if (_temp_servisni_prekidac.ppv_servisni_prekidac_ident) {
      params.ppv_servisni_prekidac_ident = _temp_servisni_prekidac.ppv_servisni_prekidac_ident;
    }
    if (_temp_servisni_prekidac.ppv_servisni_prekidac_naziv) {
      params.ppv_servisni_prekidac_naziv = _temp_servisni_prekidac.ppv_servisni_prekidac_naziv;
    }
  }
  if (true) {
    if (_temp_servisni_prekidac.ppv_kontaktor_ident) {
      params.ppv_kontaktor_ident = _temp_servisni_prekidac.ppv_kontaktor_ident;
      // params.ppv_kontaktor_kolicina = _temp_servisni_prekidac.ppv_kontaktor_kolicina;
    }
    if (_temp_servisni_prekidac.ppv_kontaktor_naziv) {
      params.ppv_kontaktor_naziv = _temp_servisni_prekidac.ppv_kontaktor_naziv;
    }
  }
  //
  const Amortizeri = ventilator_params.Amortizeri;
  const Broj_Amortizera = Number.parseInt(ventilator_params.Broj_Amortizera);
  if (Broj_Amortizera > 0) {
    const _temp_amortizer = _novo_izracunaj_amortizer(Amortizeri, Broj_Amortizera);
    if (_temp_amortizer.ppv_amortizer_ident) {
      params.ppv_amortizer_ident = _temp_amortizer.ppv_amortizer_ident;
    }
    if (_temp_amortizer.ppv_amortizer_naziv) {
      params.ppv_amortizer_naziv = _temp_amortizer.ppv_amortizer_naziv;
    }
  }
  //
  return params;
};
//
export const _derivat_ppv_izracunaj_pomocu_ventilatora_o1_o2 = (ppv_ventilator_ident) => {
  // const ventilator_params = _novo_ventilatorParamsGet(ppv_ventilator_ident);
  const ventilator_params = _getVentilatorSingleFromLib(ppv_ventilator_ident);
  let params = {
    // ZA PPV
    ppv_o1: 0, // Rastojanje izmedju otvora el veze
    ppv_o2: 0, // Rastojanje otvora srednjih 12 otvora
    //
    ppv_vent_nanosacu: "",
    ppv_kolikootvorazaelv: 0, // Broj_otvora_za_el_vezu ;Broj otvora za spajanje fleksi veze (4,8 ili 12)
    // ppv_vent_masakg: 0,
    // ppv_vent_snagamotora: 0,
    ppv_vent_ventilator: "?",
    ppv_vent_brojamortizera: "",
    ppv_vent_amortizeri: "",
  };
  if (ventilator_params && ventilator_params.Rastojanje_izmedju_otvora_el_veze) {
    // Rastojanje izmedju otvora el veze
    const Rastojanje_izmedju_otvora_el_veze = Number.parseFloat(ventilator_params.Rastojanje_izmedju_otvora_el_veze);
    if (Rastojanje_izmedju_otvora_el_veze > 0) {
      params.ppv_o1 = Rastojanje_izmedju_otvora_el_veze; // Rastojanje izmedju otvora el veze
    }
    // Rastojanje otvora srednjih 12 otvora
    const Rastojanje_otvora_srednjih_12_otvora = Number.parseFloat(ventilator_params.Rastojanje_otvora_srednjih_12_otvora);
    if (Rastojanje_otvora_srednjih_12_otvora > 0) {
      params.ppv_o2 = Rastojanje_otvora_srednjih_12_otvora; // Rastojanje otvora srednjih 12 otvora
    }
    // Nosac ventilatora
    params.ppv_vent_nanosacu = ventilator_params.Nosac_ventilatora;
    // dodatne info
    // Snaga motora
    // params.ppv_vent_snagamotora = ventilator_params.Snaga_motora;
    // Masa kg
    // params.ppv_vent_masakg = ventilator_params.Masa_kg;
    // Broj otvora za el.vezu
    const Broj_otvora_za_el_vezu = Number.parseInt(ventilator_params.Broj_otvora_za_el_vezu);
    if (Broj_otvora_za_el_vezu > 0) {
      params.ppv_kolikootvorazaelv = Broj_otvora_za_el_vezu;
    }
    //
    params.ppv_vent_brojamortizera = ventilator_params.Broj_Amortizera;
    params.ppv_vent_amortizeri = ventilator_params.Amortizeri;
    //
  }
  //
  return params;
};


// 1B) ZA NOSAČ VENTILATORA kad se izabere ventilator
export const _derivat_ppv_i_ppvnosacv_izracunaj_pomocu_ventilatora_za_nosac_ = (state, pods_input) => {
  const {
    // msirinaunutrasnjaizmedjupregradnih,
    duzinamodula,
    // NJ 2024-12-20: Koristimo samo spoljašnje dimenzija modula za pods_input
    vrstaprofila,
    msirinaspoljasnja,
  } = pods_input;
  const {
    ppv_ventilator_ident, ppv_brojventilatora, ppvnosacv_smermontaze, ppvnosacv_brojventilatoraponosacu,
    ppv_isnapregradnom,
    ppvnosacv_pregradniprofil,
  } = state;
  //
  const {
    unutrasnjaIzmedjuPregradnih: msirinaunutrasnjaizmedjupregradnih, // preimenujemo  u msirinaunutrasnjaizmedjupregradnih
  } = _derivatModulDimenzije_sve_unutrasnje_iz_spoljasnje(msirinaspoljasnja, vrstaprofila);
  //
  // const ventilator_params = _novo_ventilatorParamsGet(ppv_ventilator_ident);
  const ventilator_params = _getVentilatorSingleFromLib(ppv_ventilator_ident);
  let params = {
    // ZA PPV
    ppv_vent_nanosacu: "",
    //
    ppv_vent_ventilator: "?",
    // ZA NOSAČ
    ppvnosacv_brojventilatoraponosacu: -1,
    ppvnosacv_duzinanosacal: 0,
    ppvnosacv_precnikotvora: 0,
    ppvnosacv_l1: 0,
    ppvnosacv_l2: 0,
    ppvnosacv_l3: 0,
    kolicina: 0,
  };
  //
  if (ppv_brojventilatora === 1) {
    params.ppvnosacv_brojventilatoraponosacu = 1;
  } else {
    if (ppv_brojventilatora >= 2 && ppvnosacv_smermontaze === "PODUZINI") {
      params.ppvnosacv_brojventilatoraponosacu = 1;
    }
    if (ppv_brojventilatora >= 2 && ppvnosacv_smermontaze === "POSIRINI") {
      params.ppvnosacv_brojventilatoraponosacu = ppv_brojventilatora;
    }
  }
  if (ventilator_params && js_utils.is_object(ventilator_params)) {
    //
    // Nosac ventilatora
    params.ppv_vent_nanosacu = ventilator_params.Nosac_ventilatora; // TODO treba proveriti da li je DA ili NE
    //
    // params.ppvnosacv_precnikotvora
    const Otvor_na_nosaču_za_zavrtanj_amortizera = Number.parseInt(ventilator_params.Otvor_na_nosaču_za_zavrtanj_amortizera);
    if (Otvor_na_nosaču_za_zavrtanj_amortizera > 0) {
      params.ppvnosacv_precnikotvora = Otvor_na_nosaču_za_zavrtanj_amortizera;
    }
    //
    if (ppvnosacv_smermontaze === "POSIRINI") {
      params.kolicina = 2; // broj komada ako je po sirini onda fiksno 2 komada.
    }
    if (ppvnosacv_smermontaze === "PODUZINI") {
      params.kolicina = (ppv_brojventilatora * 2); // broj komada ako je po duzini brojventilatora * 2.
    }
    //
    if (ppvnosacv_smermontaze === "POSIRINI") {
      // automaski racunati duzian nosaa L ako je po sirini onda unutrasnjasirinaizmedju panela - 4
      params.ppvnosacv_duzinanosacal = (msirinaunutrasnjaizmedjupregradnih - 4)
    }
    if (ppvnosacv_smermontaze === "PODUZINI") {
      // ako je duzinski onda duzina modula - 4
      params.ppvnosacv_duzinanosacal = (duzinamodula - 4);
    }
    //
    //
    // L1 L2 L3
    //
    //  params.ppvnosacv_l2
    /*
    L2=
    IF $ppvnosacv_smermontaze = "po širini" THEN $Osno_rastojanje_izmedju_nosaca /// 07.11.2024 ispravka nije bilo potrebno -240
    ELSE
    IF $ppvnosacv_smermontaze = "po dužini" THEN $Rastojanje_T5 07.11.2024 ispravka nije bilo potrebno +70
    */
    if (ppvnosacv_smermontaze === "POSIRINI") {
      // IF $ppvnosacv_smermontaze = "po širini" THEN $Osno_rastojanje_izmedju_nosaca // 07.11.2024 ispravka nije bilo potrebno -240
      const Osno_rastojanje_izmedju_nosaca = Number.parseInt(ventilator_params.Osno_rastojanje_izmedju_nosaca);
      if (Osno_rastojanje_izmedju_nosaca > 0) {
        params.ppvnosacv_l2 = Osno_rastojanje_izmedju_nosaca;
      }
    }
    if (ppvnosacv_smermontaze === "PODUZINI") {
      // IF $ppvnosacv_smermontaze = "po dužini" THEN $Rastojanje_T5 // 07.11.2024 ispravka nije bilo potrebno +70
      const Rastojanje_T5 = Number.parseInt(ventilator_params.Rastojanje_T5);
      if (Rastojanje_T5 > 0) {
        params.ppvnosacv_l2 = Rastojanje_T5;
      }
    }
    //
    // params.ppvnosacv_l1
    // L1=
    if (ppvnosacv_smermontaze === "POSIRINI") {
      // IF $ppvnosacv_smermontaze = "po širini" THEN ($ppvnosacv_duzinanosacal-($broj_ventilatora_po_nosacu*L2))/($ppv_brojventilatora-1)
      // Ovo nije dobro /($ppv_brojventilatora-1) ispravno je /($broj_ventilatora_po_nosacu+1)
      // IF $ppvnosacv_smermontaze = "po širini" THEN ($ppvnosacv_duzinanosacal-$broj_ventilatora_po_nosacu*L2))/($broj_ventilatora_po_nosacu+1) dobijamo L1=458 što je ispravno
      params.ppvnosacv_l1 = (params.ppvnosacv_duzinanosacal - (params.ppvnosacv_brojventilatoraponosacu * params.ppvnosacv_l2)) / (params.ppvnosacv_brojventilatoraponosacu + 1); // TODO treba zaokruzivanje
      //
      if (ppvnosacv_brojventilatoraponosacu >= 2) {
        /*
        NJ 2024-11-20: 
        Ovde moramo da promenimo logiku za proračun L1 kada je $ppvnosacv_smermontaze = "po širini" i broj ventilatora >=2
  
        Pre svega potrebno je dodati polja: "Pregradni profil" sa vrednostima koje može imati vrednosti DA/NE i polje "Na osnovnom" (slično kao kod PPV-a, polje "na pregradnom" i odnosi se na kom profilu je montaža) koje takođe može imati vrednosti DA/NE.
  
        Formula za proračun L1 je:
        =((((L-(IF($Na osnovnom="DA";27;0))-IF($Pregradni profil="DA";43;0))/2)-(L2*$ppvnosacv_brojventilatoraponosacu))/2)+IF($Na osnovnom="DA";13;0)
  
        Koristi se funkcija ROUND sa 0 decimala.
        */
        /*
        params.ppvnosacv_l1 = ((((params.ppvnosacv_duzinanosacal - (XIF(ppv_isnapregradnom === "NE", 27, 0)) - XIF(ppvnosacv_pregradniprofil === "DA", 43, 0)) / 2) - (params.ppvnosacv_l2 * ppvnosacv_brojventilatoraponosacu)) / 2) + XIF(ppv_isnapregradnom === "NE", 13, 0);
        */
        /*
        NJ 2024-12-10
        Trenutno je 
        =((((L-(IF($Na osnovnom="DA";27;0))-IF($Pregradni profil="DA";43;0))/2)-(L2*$ppvnosacv_brojventilatoraponosacu))/2)+IF($Na osnovnom="DA";13;0)`
        Potrebno je:
        =((L-IF($Na osnovnom="DA";27;0)-IF($Pregradni profil="DA";43;0)-(L2*$ppvnosacv_brojventilatoraponosacu)/4)+IF($Na osnovnom="DA";13;0)
        ovo je formula iz excella:
        =((T18 - IF(J8="DA"; 27; 0) - IF(I8="DA"; 43; 0) - G2*W18) / 4) + IF(J8="DA"; 13; 0)
        */
        const T18 = params.ppvnosacv_duzinanosacal;
        const J8 = ppv_isnapregradnom;
        const I8 = ppvnosacv_pregradniprofil;
        const G2 = ppvnosacv_brojventilatoraponosacu;
        const W18 = params.ppvnosacv_l2;
        params.ppvnosacv_l1 = ((T18 - XIF(J8 === "NE", 27, 0) - XIF(I8 === "DA", 43, 0) - G2 * W18) / 4) + XIF(J8 === "NE", 13, 0);
      }
    }
    if (ppvnosacv_smermontaze === "PODUZINI") {
      // IF $ppvnosacv_smermontaze = "po dužini" THEN 100+$rastojanje_T6
      const Rastojanje_T6 = Number.parseInt(ventilator_params.Rastojanje_T6);
      if (Rastojanje_T6 > 0) {
        params.ppvnosacv_l1 = (100 + Rastojanje_T6);
      }
    }
    //
    // params.ppvnosacv_l3
    // L3=L-(L2*$broj_ventilatora_po_nosacu)-L1
    params.ppvnosacv_l3 = params.ppvnosacv_duzinanosacal - (params.ppvnosacv_l2 * params.ppvnosacv_brojventilatoraponosacu) - params.ppvnosacv_l1;
    //
  }
  //
  // NJ: Potrebno je parametre L1,L2, L3 zaokružiti na broj manje.
  // NJ 2024-12-10: Parametri L1, L2, L3 se zaokruzuju funkcijom ROUND na 0 decimala.
  params.ppvnosacv_l1 = ROUND(params.ppvnosacv_l1, 0);
  params.ppvnosacv_l2 = ROUND(params.ppvnosacv_l2, 0);
  params.ppvnosacv_l3 = ROUND(params.ppvnosacv_l3, 0);
  //
  return params;
};


// 2) kada se izabere koliko kolona
export const _derivat_ppv_izracunaj_kolikoredova_i_kolikosekcija = (ppv_brojventilatora, ppv_kolikokolona) => {
  let ppv_kolikoredova = 0;
  let ppv_kolikosekcija = 0;
  if (ppv_brojventilatora > 0 && ppv_kolikokolona > 0) {
    ppv_kolikoredova = ROUNDUP((ppv_brojventilatora / ppv_kolikokolona), 0);
    ppv_kolikosekcija = ppv_kolikokolona * ppv_kolikoredova;
  }
  return { ppv_kolikoredova, ppv_kolikosekcija };
};


// 3) izracunava se samo tip da l ije 1D ili 4D
// export const _derivat_ppv_izracunaj_tip = (ppv_brojventilatora, ppv_b, ppv_h, ppv_kolikoredova) => {
export const _derivat_ppv_izracunaj_tip = (state) => {
  const {
    ppv_brojventilatora, ppv_b, ppv_h, ppv_kolikoredova,
    ppv_b1,
  } = state;
  //
  const Broj_ventilatora = ppv_brojventilatora;
  console.log('ppv_brojventilatora, ppv_b, ppv_h, ppv_kolikoredova', ppv_brojventilatora, ppv_b, ppv_h, ppv_kolikoredova);
  const Sirina_panela = ppv_b;
  const Visina_panela = ppv_h;
  const Ventilatora_po_sirini = ppv_kolikoredova;
  //
  // let tip = "?";
  let tip = "";
  // NOVO
  if (Broj_ventilatora === 1) {
    tip = TIP_1D;
    if (Sirina_panela > 1217 && Visina_panela > 952) {
      tip = TIP_4D;
    }
  }
  if (Broj_ventilatora === 2) {
    tip = TIP_1D;
    if (Ventilatora_po_sirini === 2 && Visina_panela > 1290) {
      tip = TIP_4D;
    }
  }
  if (Broj_ventilatora === 3) {
    // 3 VENTILATORA, UVEK DAJE 1D
    tip = TIP_1D;
  }
  if (Broj_ventilatora === 4) {
    tip = TIP_1D;
    if (Ventilatora_po_sirini === 2) {
      tip = TIP_4D;
    }
  }
  if (Number.isInteger(Broj_ventilatora) && Broj_ventilatora > 4 && Broj_ventilatora < 13) {
    tip = TIP_1D;
  }
  //
  /*
  if (ppv_b1 === 600 || ppv_b1 > 600) {
    // NJ 2025-03-20: Ovaj tip PPV-a se koristi kada je parametar B1>=600.
    tip = TIP_6D;
  }
  */
  //
  console.log('+++', Broj_ventilatora, typeof Broj_ventilatora, 'izracunao tip:', tip);
  //
  return tip;
};


////


//
export const _derivat_ppv_izracunaj_servisni_prekidac_kolicina = (state) => {
  let ppv_servisni_prekidac_kolicina = 0;
  let ppv_kontaktor_kolicina = 0;
  let ppv_amortizer_kolicina = 0;
  const {
    ppv_brojventilatora,
    ppv_vent_brojamortizera,
  } = state;
  if (ppv_brojventilatora > 0) {
    ppv_servisni_prekidac_kolicina = ppv_brojventilatora; // Količina je 1 po ventilatoru.
    ppv_kontaktor_kolicina = ppv_brojventilatora; // količina je 1 po ventilatoru.
    if (ppv_vent_brojamortizera && Number.parseInt(ppv_vent_brojamortizera) > 0) {
      // Broj amortizera, nalazimo u istoj tabeli u polju $Broj_Amortizera. Konačan broj amortizera dobija se množenjem polja $ppv_brojventilatora sa vrednošću iz polja $Broj_Amortizera.
      ppv_amortizer_kolicina = ppv_brojventilatora * Number.parseInt(ppv_vent_brojamortizera);
    }
  }
  return {
    ppv_servisni_prekidac_kolicina,
    ppv_kontaktor_kolicina,
    ppv_amortizer_kolicina,
  };
};


//
export const _derivat_ppv_izracunaj_hb123_pack = (state) => {
  //
  let ppv_b4 = 0;
  let ppv_h4 = 0;
  let ppv_b2 = 0;
  let ppv_h2 = 0;
  let ppv_b1 = 0;
  let ppv_b3 = 0;
  let ppv_h1 = 0;
  let ppv_h3 = 0;
  //
  let ppv_b1_6d = 0;
  let ppv_b3_6d = 0;
  //
  if (
    state.ppv_b > 0 &&
    state.ppv_h > 0 &&
    state.ppv_kolikokolona > 0 &&
    state.ppv_kolikoredova > 0 &&
    (state.ppv_o1 > 0 || state.ppv_o1 === 0) &&
    (state.ppv_o1zazor > 0 || state.ppv_o1zazor === 0) &&
    (state.ppv_o2 > 0 || state.ppv_o2 === 0) &&
    (state.ppv_ventilator_ident) &&
    (state.ppv_isnapregradnom === "DA" || state.ppv_isnapregradnom === "NE")
  ) {
    // ako su ulazni arguenti ispravni
    // TODO treba bolja provera za state.ppv_ventilator_ident
    //
    const { ppv_b, ppv_h, ppv_kolikokolona, ppv_kolikoredova, ppv_o1, ppv_o1zazor, ppv_o2, ppv_ventilator_ident, ppv_isnapregradnom, tervrstaprofila_50_ili_70 } = state;
    //
    ppv_b4 = ppv_b / ppv_kolikokolona; // sirina ppv sekcije
    ppv_h4 = ppv_h / ppv_kolikoredova; // visina ppv sekcije
    ppv_b2 = ppv_o1 - (2 * ppv_o1zazor); // dimenzija rupe
    ppv_h2 = ppv_b2; // dimenzija rupe. Ista sirina i visina rupe.
    ppv_b1 = (ppv_b4 - ppv_b2) / 2; // sirina od pocetka leve strane do rupe 
    ppv_b3 = ppv_b1; // sirina od rupe do kraja desne strane - Ista b1 i b3 jer je rupa po sirini u centru.
    //
    ppv_b1_6d = ppv_b1 / 2;
    ppv_b3_6d = ppv_b1_6d;
    //
    // Izracunavanje ppv_h1 i preuzimanje parametara ventilatora
    console.log('Sledi izracunavanje ppv_h1 i preuzimanje parametara ventilatora');
    ppv_h1 = 0; // visina od dna sekcije do rupe
    // za sada simuliramo da su viseci ventilatori
    let ventilator_params = _getVentilatorSingleFromLib(ppv_ventilator_ident);
    console.log('PARAMETRI VENTILATORA IZ BIBLIOTEKE: ', ventilator_params);
    if (ventilator_params && ventilator_params.Nosac_ventilatora === "DA") {
      console.log('SLUČAJ Nosac_ventilatora "DA" znaci da su ventilatori na nosaču.');
      let Visina_amortizera = 0;
      let Visina_nosaca = 0;
      let Visina_do_ose_vratila_radnog_kola = 0;
      if (Number.parseFloat(ventilator_params.Visina_amortizera) > 0) {
        Visina_amortizera = Number.parseFloat(ventilator_params.Visina_amortizera);
      }
      if (Number.parseFloat(ventilator_params.Visina_nosaca) > 0) {
        Visina_nosaca = Number.parseFloat(ventilator_params.Visina_nosaca);
      }
      // if (Number.parseFloat(ventilator_params.Visina_do_ose_vratila_radnog_kola) > 0) {
      if (Number.parseFloat(ventilator_params.Visina_do_ose_vratila_radnog_kola) > 0) {
        Visina_do_ose_vratila_radnog_kola = Number.parseFloat(ventilator_params.Visina_do_ose_vratila_radnog_kola);
      }
      console.log('Protumačili smo sledeće parametre od ventilatora:');
      console.log('Visina_amortizera', Visina_amortizera);
      console.log('Visina_nosaca', Visina_nosaca);
      console.log('Visina_do_ose_vratila_radnog_kola', Visina_do_ose_vratila_radnog_kola);
      //
      // Nosac_ventilatora "DA" znači da ventilatori postoji niosač i ventilator stoji na nosaču.
      if (ppv_isnapregradnom === "DA") {
        console.log('SLUČAJ ppv_isnapregradnom "DA"');
        console.log('Računamo po formuli: ppv_h1 = Visina_amortizera + Visina_nosaca + Visina_do_ose_vratila_radnog_kola - (ppv_h2 / 2);');
        ppv_h1 = Visina_amortizera + Visina_nosaca + Visina_do_ose_vratila_radnog_kola - (ppv_h2 / 2);
      } else {
        console.log('SLUČAJ ppv_isnapregradnom "NE"');
        console.log('ppv_h2', ppv_h2);
        console.log('Računamo po formuli: ppv_h1 = Visina_amortizera + Visina_nosaca + Visina_do_ose_vratila_radnog_kola - (ppv_h2 / 2) - 15;');
        if (tervrstaprofila_50_ili_70 === '50') {
          ppv_h1 = Visina_amortizera + Visina_nosaca + Visina_do_ose_vratila_radnog_kola - (ppv_h2 / 2);
        } else if (tervrstaprofila_50_ili_70 === '70') {
          console.log('SLUČAJ ppv_isnapregradnom "NE" i tervrstaprofila_50_ili_70 "70"');
          ppv_h1 = Visina_amortizera + Visina_nosaca + Visina_do_ose_vratila_radnog_kola - (ppv_h2 / 2) - 15; // DL 2023-11-27: 15mm je razlika u visini izmedju osnovnog i pregradnog profila samo u slučaju kada je vrstaprofila '70'. Dodatno u ovom slučaju PPV je na osnovnom profilu a ventilator leži na podu koji je u ravni pregradnog profila što znači da je donja tačka ventilatora u ovom slučaju 15mm niže u odnosu na donju tačku PPV-a.
        }
      }
    } else {
      // Nosac_ventilatora "NE" znaci da su viseci ventilatorri (nemaju nosać) i pozicija otvora po vertikali je u centru.
      console.log('SLUČAJ Nosac_ventilatora "NE" znaci da su viseci ventilatorri (nemaju nosać) i pozicija otvora po vertikali je u centru.');
      console.log('ppv_h4', ppv_h4);
      console.log('ppv_h2', ppv_h2);
      console.log('Računamo po formuli: ppv_h1 = (ppv_h4 - ppv_h2) / 2; // ovo je centriranje po visini');
      ppv_h1 = (ppv_h4 - ppv_h2) / 2; // ovo je centriranje po visini
    }
    console.log('REZULTAT: Izračunali smo ppv_h1', ppv_h1);
    /*
    "((Visina panela/Podsklopova po visini)-Sirina otvora)/2
    // Ako su ventilatori GR odnosno bez nosaca proveriti iz baze
    IF(Na pregradnom=""true"";Visina amortizera+Visina nosaca+Osa otvora po visini-(Sirina otvora/2)
    IF(Na pregradnom=""false"";Visina amortizera+Visina nosaca+Osa otvora po visini-(Sirina otvora/2)-15"
    */
    // izracunavanje ppv_h3
    ppv_h3 = ppv_h4 - ppv_h1 - ppv_h2; // visina iznad rupe do vrha sekcije
    console.log('REZULTAT: Izračunali smo ppv_h3', ppv_h3);
    //
  }
  //
  return {
    ppv_b4,
    ppv_h4,
    ppv_b2,
    ppv_h2,
    ppv_b1,
    ppv_b3,
    ppv_h1,
    ppv_h3,
    ppv_b1_6d,
    ppv_b3_6d,
  };
};


/*
export const _derivat_ppv_izracunaj_hb123_pack_OLD = (ppv_b, ppv_h, ppv_kolikokolona, ppv_kolikoredova, ppv_o1, ppv_o1zazor, ppv_o2, ppv_ventilator_ident, ppv_isnapregradnom) => {
  const ppv_b4 = ppv_b / ppv_kolikokolona; // sirina ppv sekcije
  const ppv_h4 = ppv_h / ppv_kolikoredova; // visina ppv sekcije
  const ppv_b2 = ppv_o1 - (2 * ppv_o1zazor); // dimenzija rupe
  const ppv_h2 = ppv_b2; // dimenzija rupe. Ista sirina i visina rupe.
  const ppv_b1 = (ppv_b4 - ppv_b2) / 2; // sirina od pocetka do rupe 
  const ppv_b3 = ppv_b1; // sirina od rupe do kraja - Ista b1 i b3 jer je rupa po sirini u centru.
  let ppv_h1 = 0; // visina od dna sekcije do rupe
  if (true) {
    // za sada simuliramo da su viseci ventilatori
    ppv_h1 = (ppv_h4 - ppv_h2) / 2;
    let ventilator_params = _novo_ventilatorParamsGet(ppv_ventilator_ident);
    if (ventilator_params && ventilator_params.Nosac_ventilatora === "DA") {
      if (ppv_isnapregradnom === "DA") {
        ppv_h1 = ventilator_params.Visina_amortizera + ventilator_params.Visina_nosaca + ventilator_params.Visina_do_ose_vratila_radnog_kola - (ppv_b2 / 2);
      } else {
        ppv_h1 = ventilator_params.Visina_amortizera + ventilator_params.Visina_nosaca + ventilator_params.Visina_do_ose_vratila_radnog_kola - (ppv_b2 / 2) - 15; // 15mm je ???
      }
    }
  }
  const ppv_h3 = ppv_h4 - ppv_h1 - ppv_h2; // visina iznad rupe do vrha sekcije
  return {
    ppv_b4,
    ppv_h4,
    ppv_b2,
    ppv_h2,
    ppv_b1,
    ppv_b3,
    ppv_h1,
    ppv_h3,
  };
};
*/


////


//
const _povrsina_1d_i_4d_elemenata = (sirina_mm, visina_mm) => {
  const DODATAK_ZA_SAVIJANJE = 40.8; // DUSAN 2023-09-12 umesto 41.1 da bude =40.8
  const povrsina = ROUNDUP((((sirina_mm + DODATAK_ZA_SAVIJANJE) * (visina_mm + DODATAK_ZA_SAVIJANJE)) / 1000000), 2); // konvertovana u m2 i DL 2023-09-12: zaokruzena na 2 decimale ROUNDUP.
  return povrsina;
};


//
export const _derivat_terkk_ppv_izracunaj_za_subform_arr = (state, _hb123_pack) => {
  const {
    ppv_tip, ppv_kolikokolona, ppv_kolikoredova, ppv_kolikosekcija, ppv_brojventilatora, ppv_isojacanjaposirini, ppv_isojacanjapovisini, /*_hb123_pack,*/ ppv_b, ppv_h, ppv_sirinaojacanja,

    ppv_servisni_prekidac_ident,
    ppv_servisni_prekidac_naziv,
    ppv_servisni_prekidac_kolicina,
    ppv_kontaktor_ident,
    ppv_kontaktor_naziv,
    ppv_kontaktor_kolicina,
    ppv_amortizer_ident,
    ppv_amortizer_naziv,
    ppv_amortizer_kolicina,
  } = state;
  //
  console.log('_derivat_terkk_ppv_izracunaj_za_subform_arr state', ppv_kolikokolona, ppv_kolikoredova);
  // let ppv_kolikokolona = state.ppv_kolikokolona;
  // let ppv_kolikoredova = state.ppv_kolikoredova;
  const NE = "NE";
  const DA = "DA";
  const {
    ppv_b4,
    ppv_h4,
    ppv_b2,
    ppv_h2, // ne koristi se jer 3D delovi su visine cele vertikale TODO ???
    ppv_b1,
    ppv_b3,
    ppv_h1,
    ppv_h3,
    ppv_b1_6d,
    ppv_b3_6d,
  } = _hb123_pack;
  // 
  let counter_sekcija = 0;
  let counter_oznaka = 0;
  let _arr = [];
  //
  const _add_sekcija_smart = (sekcija, is_bez_otvora) => {
    // pamtno dodaje ili jednu 1D sekciju ili po 4 4D sekcije
    //
    const _da_ako_nije_eksterna = (is_eksterna) => {
      let interna;
      if (is_eksterna === true) {
        interna = NE;
      } else {
        interna = DA;
      }
      return interna;
    };
    //
    if (ppv_tip === TIP_1D) {
      // 1D
      counter_oznaka++;
      const podsekcija_1d = {
        tempkey: counter_oznaka,
        tip: "PPV_1D_SEKCIJA",
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "1D",
        cncprogram1: "Lim PPV-1D.S4",
        lang: "terkk$ppv_sekcija/1D",
        ppv_medjuspoj_top: _da_ako_nije_eksterna(sekcija.sekcija_ekster_top),
        ppv_medjuspoj_bottom: _da_ako_nije_eksterna(sekcija.sekcija_ekster_bottom),
        ppv_medjuspoj_left: _da_ako_nije_eksterna(sekcija.sekcija_ekster_left),
        ppv_medjuspoj_right: _da_ako_nije_eksterna(sekcija.sekcija_ekster_right),
        sirina: ppv_b4, // sirina ppv sekcije
        visina: ppv_h4, // visina ppv sekcije
        kolicina: 1,
      };
      if (is_bez_otvora === true) {
        podsekcija_1d.ppv_bezotvora = true; // NJ 2025-03-20: Za 1D izabcujemo POKLOPCIC i upisujemo parametar ppv_bezotvora.
      }
      // PPV - Pregradni panel ventilatora_Rev 1.xlsx, Deo -P1-P2..., Deo A1
      // (Sirina dela + Dodatak za savijanje sirina)*(Visina dela + Dodatak za savijanje visina)/1000000
      podsekcija_1d.povrsina = _povrsina_1d_i_4d_elemenata(podsekcija_1d.sirina, podsekcija_1d.visina);
      podsekcija_1d.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, podsekcija_1d.ppv_oznaka, podsekcija_1d.sirina, podsekcija_1d.visina);
      _arr = [..._arr, podsekcija_1d];
    } else if (ppv_tip === TIP_4D) {
      // 4D
      const default_4d_podsekcija = {
        tip: "PPV_4D_SEKCIJA",
        ppv_medjuspoj_top: DA,
        ppv_medjuspoj_bottom: DA,
        ppv_medjuspoj_left: DA,
        ppv_medjuspoj_right: DA,
        kolicina: 1,
      };
      // P1 - CELA LEVA STRANA
      counter_oznaka++;
      let item1 = {
        ...default_4d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "4D_LEVO",
        cncprogram1: "Lim PPV-4D-LEVO.S4",
        lang: "terkk$ppv_sekcija/4D_LEVO",
        ppv_medjuspoj_top: _da_ako_nije_eksterna(sekcija.sekcija_ekster_top),
        ppv_medjuspoj_bottom: _da_ako_nije_eksterna(sekcija.sekcija_ekster_bottom),
        ppv_medjuspoj_left: _da_ako_nije_eksterna(sekcija.sekcija_ekster_left),
        // desna strana ovde uvek ima medjuspoj
        sirina: ppv_b1, // sirina od pocetka leve strane do rupe 
        visina: ppv_h4, // visina ppv sekcije
      };
      item1.povrsina = _povrsina_1d_i_4d_elemenata(item1.sirina, item1.visina);
      item1.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item1.ppv_oznaka, item1.sirina, item1.visina);
      _arr = [..._arr, item1];
      // P2 - DOLE U SREDINI
      counter_oznaka++;
      let item2 = {
        ...default_4d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "4D_DOLE",
        cncprogram1: "Lim PPV-4D-DOLE.S4",
        lang: "terkk$ppv_sekcija/4D_DOLE",
        ppv_medjuspoj_top: NE, // gornja strana ovde je nuz rupu i nikad nema medjuspoj
        ppv_medjuspoj_bottom: _da_ako_nije_eksterna(sekcija.sekcija_ekster_bottom),
        // leva strana ovde uvek ima medjuspoj
        // desna strana ovde uvek ima medjuspoj
        sirina: ppv_b2, // dimenzija rupe
        visina: ppv_h1, // visina od dna sekcije do rupe
      };
      item2.povrsina = _povrsina_1d_i_4d_elemenata(item2.sirina, item2.visina);
      item2.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item2.ppv_oznaka, item2.sirina, item2.visina);
      _arr = [..._arr, item2];
      // P3 - CELA DESNA STRANA
      counter_oznaka++;
      let item3 = {
        ...default_4d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "4D_DESNO",
        cncprogram1: "Lim PPV-4D-DESNO.S4",
        lang: "terkk$ppv_sekcija/4D_DESNO",
        // leva strana ovde uvek ima medjuspoj
        ppv_medjuspoj_right: _da_ako_nije_eksterna(sekcija.sekcija_ekster_right),
        ppv_medjuspoj_top: _da_ako_nije_eksterna(sekcija.sekcija_ekster_top),
        ppv_medjuspoj_bottom: _da_ako_nije_eksterna(sekcija.sekcija_ekster_bottom),
        sirina: ppv_b3, // sirina od rupe do kraja desne strane
        visina: ppv_h4, // visina ppv sekcije
      };
      item3.povrsina = _povrsina_1d_i_4d_elemenata(item3.sirina, item3.visina);
      item3.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item3.ppv_oznaka, item3.sirina, item3.visina);
      _arr = [..._arr, item3];
      // P4 - GORE U SREDINI
      counter_oznaka++;
      let item4 = {
        ...default_4d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "4D_GORE",
        cncprogram1: "Lim PPV-4D-GORE.S4",
        lang: "terkk$ppv_sekcija/4D_GORE",
        ppv_medjuspoj_top: _da_ako_nije_eksterna(sekcija.sekcija_ekster_top),
        ppv_medjuspoj_bottom: NE, // donja strana ovde je nuz rupu i nikad nema medjuspoj
        // leva strana ovde uvek ima medjuspoj
        // desna strana ovde uvek ima medjuspoj
        sirina: ppv_b2, // dimenzija rupe
        visina: ppv_h3, // visina iznad rupe do vrha sekcije
      };
      item4.povrsina = _povrsina_1d_i_4d_elemenata(item4.sirina, item4.visina);
      item4.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item4.ppv_oznaka, item4.sirina, item4.visina);
      _arr = [..._arr, item4];
    } else if (ppv_tip === TIP_6D) {
      // 4D
      const default_6d_podsekcija = {
        tip: "PPV_6D_SEKCIJA",
        ppv_medjuspoj_top: DA,
        ppv_medjuspoj_bottom: DA,
        ppv_medjuspoj_left: DA,
        ppv_medjuspoj_right: DA,
        kolicina: 1,
      };
      // 6D P1 - CELA LEVA STRANA
      counter_oznaka++;
      let item1 = {
        ...default_6d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "6D_LEVO",
        cncprogram1: "Lim PPV-6D-P1.S4",
        lang: "terkk$ppv_sekcija/6D_P1",
        ppv_medjuspoj_top: _da_ako_nije_eksterna(sekcija.sekcija_ekster_top),
        ppv_medjuspoj_bottom: _da_ako_nije_eksterna(sekcija.sekcija_ekster_bottom),
        ppv_medjuspoj_left: _da_ako_nije_eksterna(sekcija.sekcija_ekster_left),
        // ppv_medjuspoj_right: _da_ako_nije_eksterna(sekcija.sekcija_ekster_right),
        // desna strana ovde uvek ima medjuspoj
        sirina: ppv_b1_6d, // sirina od pocetka leve strane do rupe 
        visina: ppv_h4, // visina ppv sekcije
      };
      item1.povrsina = _povrsina_1d_i_4d_elemenata(item1.sirina, item1.visina);
      item1.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item1.ppv_oznaka, item1.sirina, item1.visina);
      _arr = [..._arr, item1];
      // 6D P2 - LEVA BLIZE SREDINI
      counter_oznaka++;
      let item2 = {
        ...default_6d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "6D_LEVO_2",
        cncprogram1: "Lim PPV-6D-P2.S4",
        lang: "terkk$ppv_sekcija/6D_P2",
        ppv_medjuspoj_top: _da_ako_nije_eksterna(sekcija.sekcija_ekster_top),
        ppv_medjuspoj_bottom: _da_ako_nije_eksterna(sekcija.sekcija_ekster_bottom),
        // ppv_medjuspoj_left: _da_ako_nije_eksterna(sekcija.sekcija_ekster_left),
        // ppv_medjuspoj_right: _da_ako_nije_eksterna(sekcija.sekcija_ekster_right),
        // leva i desna strana ovde uvek ima medjuspoj
        sirina: ppv_b1_6d, // sirina +++
        visina: ppv_h4, // visina ppv sekcije
      };
      item2.povrsina = _povrsina_1d_i_4d_elemenata(item2.sirina, item2.visina);
      item2.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item2.ppv_oznaka, item2.sirina, item2.visina);
      _arr = [..._arr, item2];
      // 6D P3 - DOLE U SREDINI
      counter_oznaka++;
      let item3 = {
        ...default_6d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "6D_DOLE",
        cncprogram1: "Lim PPV-6D-P3.S4",
        lang: "terkk$ppv_sekcija/6D_P3",
        ppv_medjuspoj_top: NE, // gornja strana ovde je nuz rupu i nikad nema medjuspoj
        ppv_medjuspoj_bottom: _da_ako_nije_eksterna(sekcija.sekcija_ekster_bottom),
        // leva strana ovde uvek ima medjuspoj
        // desna strana ovde uvek ima medjuspoj
        sirina: ppv_b2, // dimenzija rupe
        visina: ppv_h1, // visina od dna sekcije do rupe
      };
      item3.povrsina = _povrsina_1d_i_4d_elemenata(item3.sirina, item3.visina);
      item3.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item3.ppv_oznaka, item3.sirina, item3.visina);
      _arr = [..._arr, item3];
      // P4 - GORE U SREDINI
      counter_oznaka++;
      let item4 = {
        ...default_6d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "6D_GORE",
        cncprogram1: "Lim PPV-6D-P4.S4",
        lang: "terkk$ppv_sekcija/6D_P4",
        ppv_medjuspoj_top: _da_ako_nije_eksterna(sekcija.sekcija_ekster_top),
        ppv_medjuspoj_bottom: NE, // donja strana ovde je nuz rupu i nikad nema medjuspoj
        // leva strana ovde uvek ima medjuspoj
        // desna strana ovde uvek ima medjuspoj
        sirina: ppv_b2, // dimenzija rupe
        visina: ppv_h3, // visina iznad rupe do vrha sekcije
      };
      item4.povrsina = _povrsina_1d_i_4d_elemenata(item4.sirina, item4.visina);
      item4.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item4.ppv_oznaka, item4.sirina, item4.visina);
      _arr = [..._arr, item4];
      // 6D P5 - DESNA BLIZE SREDINI
      counter_oznaka++;
      let item5 = {
        ...default_6d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "6D_DESNO_2",
        cncprogram1: "Lim PPV-6D-P5.S4",
        lang: "terkk$ppv_sekcija/6D_P5",
        ppv_medjuspoj_top: _da_ako_nije_eksterna(sekcija.sekcija_ekster_top),
        ppv_medjuspoj_bottom: _da_ako_nije_eksterna(sekcija.sekcija_ekster_bottom),
        // ppv_medjuspoj_left: _da_ako_nije_eksterna(sekcija.sekcija_ekster_left),
        // ppv_medjuspoj_right: _da_ako_nije_eksterna(sekcija.sekcija_ekster_right),
        // leva i desna strana ovde uvek ima medjuspoj
        sirina: ppv_b3_6d, // sirina +++
        visina: ppv_h4, // visina ppv sekcije
      };
      item5.povrsina = _povrsina_1d_i_4d_elemenata(item5.sirina, item5.visina);
      item5.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item5.ppv_oznaka, item5.sirina, item5.visina);
      _arr = [..._arr, item5];
      // P6 - CELA DESNA STRANA
      counter_oznaka++;
      let item6 = {
        ...default_6d_podsekcija,
        tempkey: counter_oznaka,
        ppv_oznaka: "P" + counter_oznaka,
        ppv_4dstrana: "6D_DESNO",
        cncprogram1: "Lim PPV-6D-P6.S4",
        lang: "terkk$ppv_sekcija/6D_P6",
        // leva strana ovde uvek ima medjuspoj
        ppv_medjuspoj_right: _da_ako_nije_eksterna(sekcija.sekcija_ekster_right),
        ppv_medjuspoj_top: _da_ako_nije_eksterna(sekcija.sekcija_ekster_top),
        ppv_medjuspoj_bottom: _da_ako_nije_eksterna(sekcija.sekcija_ekster_bottom),
        sirina: ppv_b3_6d, // sirina +++
        visina: ppv_h4, // visina ppv sekcije
      };
      item6.povrsina = _povrsina_1d_i_4d_elemenata(item6.sirina, item6.visina);
      item6.naziv = derivatPoluproizvod_ppv_sekcija_naziv(ppv_tip, item6.ppv_oznaka, item6.sirina, item6.visina);
      _arr = [..._arr, item6];
    }
  };
  //
  if (ppv_kolikosekcija > 0 && ppv_kolikokolona > 0 && ppv_kolikoredova > 0) {
    if (ppv_tip === TIP_1D || ppv_tip === TIP_4D || ppv_tip === TIP_6D) {
      // prolazak kroz sve sekcije
      for (let rowi = 1; rowi <= ppv_kolikoredova; rowi++) {
        for (let coli = 1; coli <= ppv_kolikokolona; coli++) {
          counter_sekcija++;
          console.log('P' + counter_sekcija, 'rowi', rowi, 'coli', coli, 'ukupno', ppv_kolikoredova, ppv_kolikokolona, coli === ppv_kolikokolona);
          let sekcija = {};
          let sekcija_ekster_top = false;
          let sekcija_ekster_bottom = false;
          let sekcija_ekster_left = false;
          let sekcija_ekster_right = false;
          // redosled redova PPV sekcija ide od dole prema gore
          if (rowi === 1) {
            // prvi red ja najdonji
            sekcija_ekster_bottom = true;
          }
          if (rowi === ppv_kolikoredova) {
            // poslednji red je najgornji
            sekcija_ekster_top = true;
          }
          // redosled kolona PPV sekcija ide od dole prema gore
          if (coli === 1) {
            // prva kolone je krajnja levo
            sekcija_ekster_left = true;
          }
          if (coli === ppv_kolikokolona) {
            // poslednja kolona je krajnja desno
            sekcija_ekster_right = true;
          }
          sekcija = {
            sekcija_ekster_top,
            sekcija_ekster_bottom,
            sekcija_ekster_left,
            sekcija_ekster_right,
          };
          //
          let is_add_poklopac = false;
          let is_bez_otvora = false;
          if (ppv_brojventilatora < ppv_kolikosekcija && counter_sekcija > ppv_brojventilatora) {
            // CASE POKLOPAC or BEZOTVORA
            if (ppv_tip === TIP_1D) { // CASE 1D nece vise imati poklopac nego parametar BEZOTVORA
              // NJ 2025-03-20: Za 1D izabcujemo POKLOPCIC i upisujemo parametar ppv_bezotvora.
              is_bez_otvora = true;
            } else { // CASE svi ostali imaju poklopac
              is_add_poklopac = true;
            }
          }
          _add_sekcija_smart(sekcija, is_bez_otvora);
          // ----- nakon dodavanja sekcija, dodavanje poklopca po potrebi
          if (is_add_poklopac === true) {
            counter_oznaka++;
            const item_poklopac = {
              tip: "PPV_POKLOPCIC",
              tempkey: counter_oznaka,
              ppv_oznaka: "POK",
              ppv_4dstrana: "SREDINA",
              cncprogram1: "? TODO ?", // TODO
              lang: "terkk$ppv_sekcija/POKLOPCIC",
              ppv_medjuspoj_top: NE,
              ppv_medjuspoj_bottom: NE,
              ppv_medjuspoj_left: NE,
              ppv_medjuspoj_right: NE,
              sirina: ppv_b2,
              visina: ppv_h2,
              povrsina: -1, // TODO
              kolicina: 1,
            };
            item_poklopac.naziv = derivatPoluproizvod_ppv_poklopac_naziv(item_poklopac.ppv_oznaka, item_poklopac.sirina, item_poklopac.visina);
            _arr = [..._arr, item_poklopac];
          }
        }
      }
      // ----- nakon sekcija i poklopca sledi dodavanje ojacanje po potrebi
      // TODO sta se desava sa kolicinama da li ostanu 0 ???
      if (ppv_tip === TIP_1D || ppv_tip === TIP_4D || ppv_tip === TIP_6D) {
        const RAZVIJENA_SIRINA = 153.2;
        // OJACANJA VERTIKALNA
        let kolikovisinskihojacanja = 0;
        if (ppv_isojacanjapovisini === true && ppv_kolikokolona > 1) {
          kolikovisinskihojacanja = ppv_kolikokolona - 1; // PRIVREMENO
          counter_oznaka++;
          let reinforcement_vertical_item = {
            tempkey: counter_oznaka,
            tip: "PPV_OJACANJE_VERTIKALNO",
            ppv_oznaka: "V",
            ppv_4dstrana: "NONE",
            cncprogram1: "LimPPV-OV.S4",
            lang: "terkk$ppv_sekcija/OJACANJE_V",
            duzina: ppv_h, // visina ppv-a
            kolicina: kolikovisinskihojacanja
          };
          // PPV - Pregradni panel ventilatora_Rev 1.xlsx, Deo - R1, Ojacanje po visini
          // povrsina = Duzina * Razvijane sirina /1000000
          reinforcement_vertical_item.povrsina = (reinforcement_vertical_item.duzina * RAZVIJENA_SIRINA) / 1000000; // konvertovana u m2
          reinforcement_vertical_item.naziv = derivatPoluproizvod_ppv_ojacanje_naziv(reinforcement_vertical_item.ppv_oznaka, reinforcement_vertical_item.duzina);
          _arr.push(reinforcement_vertical_item);
        }
        // OJACANJA HORIZONTALANA
        if (ppv_isojacanjaposirini === true && ppv_kolikoredova > 1 && ppv_kolikokolona > 1 && kolikovisinskihojacanja > 0) {
          const koliko_redova_horizontalnih_ojacanja = (ppv_kolikoredova - 1);
          let koliko_u_jednom_redu_horizontalnih_krajnjih = 2; // PITANEJ da li je uvek 2? jedan krajnji levi i jedan kranji desni?!
          const koliko_u_jednom_redu_horizontalnih_sredisnjih = ppv_kolikokolona - koliko_u_jednom_redu_horizontalnih_krajnjih; //
          //
          // HORIZNOTALNO KRAJNJE
          const kolikosirinskihojacanja_krajnjih = koliko_redova_horizontalnih_ojacanja * koliko_u_jednom_redu_horizontalnih_krajnjih;
          if (kolikosirinskihojacanja_krajnjih > 0) {
            counter_oznaka++;
            let reinforcement_horizontal_item1 = {
              tempkey: counter_oznaka,
              tip: "PPV_OJACANJE_HORIZONTALNO",
              ppv_oznaka: "HK",
              ppv_4dstrana: "NONE",
              cncprogram1: "LimPPV-OH.S4",
              lang: "terkk$ppv_sekcija/OJACANJE_H",
              kolicina: kolikosirinskihojacanja_krajnjih,
            };
            // PPV - Pregradni panel ventilatora_Rev 1.xlsx, Deo - R2.1, Ojacanje po sirina na krajevima
            // B4-2*(Sirina ojacanja/2)-2
            reinforcement_horizontal_item1.duzina = ppv_b4 - (1 * (ppv_sirinaojacanja / 2)) - 2; // TODO 2 na kraju je verovatno nekakav ZAZOR???
            // Duzina * Razvijane sirina /1000000
            reinforcement_horizontal_item1.povrsina = (reinforcement_horizontal_item1.duzina * RAZVIJENA_SIRINA) / 1000000; // konvertovana u m2
            reinforcement_horizontal_item1.naziv = derivatPoluproizvod_ppv_ojacanje_naziv(reinforcement_horizontal_item1.ppv_oznaka, reinforcement_horizontal_item1.duzina);
            _arr.push(reinforcement_horizontal_item1);
          }
          //
          // HORIZNOTALNO SREDNJE
          const kolikosirinskihojacanja_srednjih = koliko_redova_horizontalnih_ojacanja * koliko_u_jednom_redu_horizontalnih_sredisnjih;
          if (kolikosirinskihojacanja_srednjih > 0) {
            counter_oznaka++;
            let reinforcement_horizontal_item2 = {
              tempkey: counter_oznaka,
              tip: "PPV_OJACANJE_HORIZONTALNO",
              ppv_oznaka: "HS",
              ppv_4dstrana: "NONE",
              cncprogram1: "LimPPV-OH.S4",
              lang: "terkk$ppv_sekcija/OJACANJE_H",
              kolicina: kolikosirinskihojacanja_srednjih,
            };
            // PPV - Pregradni panel ventilatora_Rev 1.xlsx, Deo - R2, Ojacanje po sirina i sredini
            // IF(AND(Broj ventilator = 3;Ventilatora po visini = 2);Sirina panela;B4-(Sirina ojacanja/2)-2
            reinforcement_horizontal_item2.duzina = ppv_b4 - (2 * (ppv_sirinaojacanja / 2)) - 2; // TODO 2 na kraju je verovatno nekakav ZAZOR???
            // Duzina * Razvijane sirina /1000000
            reinforcement_horizontal_item2.povrsina = (reinforcement_horizontal_item2.duzina * RAZVIJENA_SIRINA) / 1000000; // konvertovana u m2
            reinforcement_horizontal_item2.naziv = derivatPoluproizvod_ppv_ojacanje_naziv(reinforcement_horizontal_item2.ppv_oznaka, reinforcement_horizontal_item2.duzina);
            _arr.push(reinforcement_horizontal_item2);
          }
        }
      }
      //
      // * Materijal servisni prekidac
      // PPV_SERVISNI_PREKIDAC
      if (ppv_servisni_prekidac_kolicina > 0 && ppv_servisni_prekidac_ident) {
        let item = {
          tempkey: 901,
          tip: "PPV_DODATNI_MATERIJAL",
          identmaterijala: ppv_servisni_prekidac_ident,
          naziv_materijala: ppv_servisni_prekidac_naziv,
          kolicina: ppv_servisni_prekidac_kolicina,
        };
        _arr.push(item);
      }
      //
      // * Materijal prekidac 2
      // PPV POMOCNI KONTAKTOR
      if (ppv_kontaktor_kolicina > 0 && ppv_kontaktor_ident) {
        let item = {
          tempkey: 902,
          tip: "PPV_DODATNI_MATERIJAL",
          identmaterijala: ppv_kontaktor_ident,
          naziv_materijala: ppv_kontaktor_naziv,
          kolicina: ppv_kontaktor_kolicina,
        };
        _arr.push(item);
      }
      //
      // * Materijal 3 amortizer
      // PPV AMORTIZER
      if (ppv_amortizer_kolicina > 0 && ppv_amortizer_ident) {
        let item = {
          tempkey: 903,
          tip: "PPV_DODATNI_MATERIJAL",
          identmaterijala: ppv_amortizer_ident,
          naziv_materijala: ppv_amortizer_naziv,
          kolicina: ppv_amortizer_kolicina,
        };
        _arr.push(item);
      }
      //
    }
  }
  //
  return {
    // sirinapostolja,
    // duzinapostolja,
    // profili_postolja_arr,
    ppv_kolikosekcija,
    _arr,
  };
};


//
//
export const _derivat_ppvnosacv_izracunaj_tip_a_b = (Visina_nosaca) => {
  //
  /*
  TODO PPD automatsko izracunavaje tipa A ili B:
  apa je ventilarorparams.Visina_nosaca === 30 onda je tip nosaca A. A kao je 45 onda je B
  a ako nema toga onda verovatn ii niej na nosacu.
  */
  let ppvnosac_tip = "";
  if (Visina_nosaca === "30") {
    ppvnosac_tip = "A";
  }
  if (Visina_nosaca === "45") {
    ppvnosac_tip = "B";
  }
  return ppvnosac_tip;
};


//
export const _derivat_terkk_ppvnosacv_pbnode_dirty_enrich = (pbnode_state_ref, protobomp_superdata, is_init) => {
  // DIRTY ENRICH
  // TODO ...props super superProps
  // console.log('item_ref, protobomp_superdata', item_ref, protobomp_superdata);
  const item = pbnode_state_ref;
  const family = item.pbnode_family;
  let povrsina = -1;
  let _cnc = null;
  let _naziv = null;
  let _materijal = '?'; // item.identmaterijala
  let _naziv_profil_komore_50_ili_70 = '?';
  let _naziv_tip_kadice = '?';
  let _tip_klizaca_abc = '?';
  let _tip_kadice = '?';
  let _strana_maske = '?';
  let _sufix = '?';
  let _visina_20_ili_35 = -1;
  /*
  Gde su: 
 
  */
  //
  const _mat_params = _getParamsFromLibMaterijalLimParams(item.identmaterijala);
  if (is_init === true) {
    if (typeof _mat_params.naziv === 'string') {
      item.naziv_materijala = _mat_params.naziv; // DIRTY
    } else {
      item.naziv_materijala = ''; // DIRTY
    }
  }
  const _tipmetalalima = _mat_params?.naziv_materijala;
  if (_tipmetalalima === "Prohrom") {
    _materijal = "SS";
  }
  if (_tipmetalalima === "Pocinkovani") {
    _materijal = "GS";
  }
  //
  const {
    ppv_ventilator_ident,
    ppvnosacv_brojventilatoraponosacu,
    ppvnosacv_duzinanosacal,
    ppvnosacv_l1,
    ppvnosacv_l2,
    ppvnosacv_l3,
    ppvnosacv_precnikotvora,
    ppvnosacv_materijal_lim,
    ppvnosacv_materijal_lim_maska_unp,
    ppvnosacv_materijal_profil_unp_bezdimenzioni,
    ppvnosacv_unpmaska,
  } = protobomp_superdata;
  //

  //
  const ventilator_params = _getVentilatorSingleFromLib(ppv_ventilator_ident);
  const _ventilator_params_Ventilator = ventilator_params.Ventilator;

  //
  if (true) {
    // sklop
    if (family === 'terkk$ppvnosacv/SKLOP_B') {
      // Za sklop naziv je potrebno graditi na isti način kao kod UNP profila koji sam prethodno poslao
      item.distinction_key = "terkk$ppvnosacv/SKLOP_B"; // DIRTY
      item.tip = "PROFIL_UNP_B"; // DIRTY
      _naziv = "NOSAC VENTILATORA UNP " + ppvnosacv_brojventilatoraponosacu + "x" + ppvnosacv_duzinanosacal + "mm" + SPACE + _ventilator_params_Ventilator; //
      //
      item.ppvnosacv_brojventilatoraponosacu = ppvnosacv_brojventilatoraponosacu; // DIRTY
      item.ppvnosacv_duzinanosacal = ppvnosacv_duzinanosacal; // DIRTY
      item.ppvnosacv_l1 = ppvnosacv_l1; // DIRTY
      item.ppvnosacv_l2 = ppvnosacv_l2; // DIRTY
      item.ppvnosacv_l3 = ppvnosacv_l3; // DIRTY
      item.ppvnosacv_precnikotvora = ppvnosacv_precnikotvora; // DIRTY
      item.ppvnosacv_unpmaska = ppvnosacv_unpmaska; // DIRTY
    }
    //
    if (family === 'terkk$ppvnosacv/LIM_OMEGA_A') { // 3. Odnosi se na OMEGA profil
      /*
      Naziv: "NOSAC VENTILATORA OMEGA " $brojventilatoraponosacu"X"$ppvnosacv_duzinanosacal "mm" ppv_ident_ventilator iz tabele TER_TABELA_VENTILATORA polje ventilator-$mateijal(ss-prohrom GS-pocinkovani)
      Količina: jednaka je količini iz koraka 2
      Duzina1: $ppvnosacv_duzinanosacal
      Dimenzija2: 40
      Razvijena 1: $ppvnosacv_duzinanosacal
      CNC crtež: P01-10-A1-1826-227-368-SS
      "P01-10-A"$brojventilatoraponosacu"-"$ppvnosacv_duzinanosacal"-"$ppvnosac_L1"-"$ppvnosac_L2"-" $materijal(ss-prohrom, GS pocinkovani lim)
      Radnicentar 1: RC-Probijacica
      Operacija 2: OP-Savijanje
      Radni centar 2: RC-Ermaksan
      Ident materijala: IF $tipkomore HYGIENE:pro THEN LC00000K ELSE LB00000L
      Naziv materijala: IF $tipkomore HYGIENE:pro THEN LIM PROHROM 2.00 ELSE LIM POCINKOVANI 2.50
      */
      item.distinction_key = "terkk$ppvnosacv/LIM_OMEGA_A"; // DIRTY // TODO
      item.tip = "LIM_OMEGA_A"; // DIRTY
      _naziv = "NOSAC VENTILATORA OMEGA " + ppvnosacv_brojventilatoraponosacu + "x" + ppvnosacv_duzinanosacal + "mm" + SPACE + _ventilator_params_Ventilator + MINUS + _materijal; //
      js_utils.dirty_enrich_object_with_obj2_shallow(item, {
        // naziv: '? LIM_OMEGA_A',
        // kolicina: 1,
        identmaterijala: ppvnosacv_materijal_lim,
        dimenzija1: ppvnosacv_duzinanosacal,
        dimenzija2: 40,
        razvijenamera1: ppvnosacv_duzinanosacal,
        razvijenamera2: null,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRSER",
      });
      // if (_tipmetalalima === "Prohrom") {
      if (_materijal === "SS") {
        item.razvijenamera2 = 121.5; // DIRTY // Razvijena 2: IF $tipmaterijala = LC00000K THEN 121,5
      }
      // if (_tipmetalalima === "Pocinkovani") {
      if (_materijal === "GS") {
        item.razvijenamera2 = 119.8; // DIRTY // Razvijena 2: IF $tipmaterijala = LC00000L THEN 119,8
      }
      povrsina = item.razvijenamera1 + item.razvijenamera2;
      // CNC crtež: P01-10-A1-1826-227-368-SS
      // "P01-10-A"$brojventilatoraponosacu"-"$ppvnosacv_duzinanosacal"-"$ppvnosac_L1"-"$ppvnosac_L2"-" $materijal(ss-prohrom, GS pocinkovani lim)
      _cnc = "P01-10-A" + ppvnosacv_brojventilatoraponosacu + MINUS + ppvnosacv_duzinanosacal + MINUS + ppvnosacv_l1 + MINUS + ppvnosacv_l2 + MINUS + _materijal;
      //
      item.ppvnosacv_brojventilatoraponosacu = ppvnosacv_brojventilatoraponosacu; // DIRTY
      item.ppvnosacv_duzinanosacal = ppvnosacv_duzinanosacal; // DIRTY
      item.ppvnosacv_l1 = ppvnosacv_l1; // DIRTY
      item.ppvnosacv_l2 = ppvnosacv_l2; // DIRTY
      item.ppvnosacv_l3 = ppvnosacv_l3; // DIRTY
      item.ppvnosacv_precnikotvora = ppvnosacv_precnikotvora; // DIRTY
    }
    //
    if (family === 'terkk$ppvnosacv/PROFIL_UNP_B') { // 1. odnosi se na UNP profil
      /*
      Naziv: "NOSAC VENTILATORA UNP " $brojventilatoraponosacu"X"$ppvnosacv_duzinanosacal "mm" ppv_ident_ventilator iz tabele TER_TABELA_VENTILATORA polje ventilator
      Količina: jednaka je količini iz koraka 2
      Dužina: $ppvnosacv_duzinanosacal
      Levi ger: 90
      Desni ger: 90
      Operacija 1: OP-Secenje
      Radni centar: RC-Zavarivanje
      Ident materijala: PUN80BA00000
      Naziv materijela:PROFIL CS UNP 80 UN80 SIROV
      */
      item.distinction_key = "terkk$ppvnosacv/PROFIL_UNP_B"; // DIRTY // TODO
      item.tip = "PROFIL_UNP_B"; // DIRTY
      js_utils.dirty_enrich_object_with_obj2_shallow(item, {
        // naziv: '? PROFIL_UNP',
        // kolicina: 1,
        duzina: ppvnosacv_duzinanosacal,
        leviger: 90,
        desniger: 90,
        identmaterijala: ppvnosacv_materijal_profil_unp_bezdimenzioni,
        operacija1: "OPSEC",
        rc1: "RCZAV",
      });
      // Naziv: "NOSAC VENTILATORA UNP " $brojventilatoraponosacu"X"$ppvnosacv_duzinanosacal "mm" ppv_ident_ventilator iz tabele TER_TABELA_VENTILATORA polje ventilator
      _naziv = "NOSAC VENTILATORA UNP " + ppvnosacv_brojventilatoraponosacu + "x" + ppvnosacv_duzinanosacal + "mm" + SPACE + _ventilator_params_Ventilator; //
      //
      item.ppvnosacv_brojventilatoraponosacu = ppvnosacv_brojventilatoraponosacu; // DIRTY
      item.ppvnosacv_duzinanosacal = ppvnosacv_duzinanosacal; // DIRTY
      item.ppvnosacv_l1 = ppvnosacv_l1; // DIRTY
      item.ppvnosacv_l2 = ppvnosacv_l2; // DIRTY
      item.ppvnosacv_l3 = ppvnosacv_l3; // DIRTY
      item.ppvnosacv_precnikotvora = ppvnosacv_precnikotvora; // DIRTY
    }
    //
    if (family === 'terkk$ppvnosacv/UNP_MASKA') { // Odnosi se na masku UNP profila(ona
      /*
      Naziv: "MASKA NOSACA VENTILATORA " $brojventilatoraponosacu"X"$ppvnosacv_duzinanosacal "mm" ppv_ident_ventilator iz tabele TER_TABELA_VENTILATORA polje ventilator
      Količina: jednaka je količini iz koraka 2
      Duzina1: $ppvnosacv_duzinanosacal
      Dimenzija2: 81
      Razvijena 1: $ppvnosacv_duzinanosacal
      Razvijena 2: 173
      CNC crtež: P01-10-B1-MA-1826-210-1210
      "P01-10-B"$brojventilatoraponosacu"-MA-"$ppvnosacv_duzinanosacal"-"$ppvnosac_L1"-"$ppvnosac_L2
      Operacija 1: OP-Secenje
      Radnicentar 1: RC-Probijacica
      Operacija 2: OP-Savijanje
      Radni centar 2: RC-Ermaksan
      Ident materijala: LC00000D
      Naziv materijala: LIM PROHROM 0.80
      */
      item.distinction_key = "terkk$ppvnosacv/UNP_MASKA"; // DIRTY // TODO
      item.tip = "UNP_MASKA"; // DIRTY
      js_utils.dirty_enrich_object_with_obj2_shallow(item, {
        // naziv: '? MASKA',
        // kolicina: 1,
        dimenzija1: ppvnosacv_duzinanosacal,
        dimenzija2: 81,
        razvijenamera1: ppvnosacv_duzinanosacal,
        razvijenamera2: 173,
        identmaterijala: ppvnosacv_materijal_lim_maska_unp,
        operacija1: "OPSEC",
        rc1: "RCPRBAM",
        operacija2: "OPSAV",
        rc2: "RCPRBAM",
      });
      povrsina = item.razvijenamera1 + item.razvijenamera2;
      // Naziv: "MASKA NOSACA VENTILATORA " $brojventilatoraponosacu"X"$ppvnosacv_duzinanosacal "mm" ppv_ident_ventilator iz tabele TER_TABELA_VENTILATORA polje ventilator
      _naziv = "MASKA NOSACA VENTILATORA " + ppvnosacv_brojventilatoraponosacu + "x" + ppvnosacv_duzinanosacal + "mm" + SPACE + _ventilator_params_Ventilator;
      // CNC crtež: P01-10-B1-MA-1826-210-1210
      // "P01-10-B"$brojventilatoraponosacu"-MA-"$ppvnosacv_duzinanosacal"-"$ppvnosac_L1"-"$ppvnosac_L2
      _cnc = "P01-10-B" + ppvnosacv_brojventilatoraponosacu + "-MA-" + ppvnosacv_duzinanosacal + MINUS + ppvnosacv_l1 + MINUS + ppvnosacv_l2;
      //
      item.ppvnosacv_brojventilatoraponosacu = ppvnosacv_brojventilatoraponosacu; // DIRTY
      item.ppvnosacv_duzinanosacal = ppvnosacv_duzinanosacal; // DIRTY
      item.ppvnosacv_l1 = ppvnosacv_l1; // DIRTY
      item.ppvnosacv_l2 = ppvnosacv_l2; // DIRTY
      item.ppvnosacv_l3 = ppvnosacv_l3; // DIRTY
      item.ppvnosacv_precnikotvora = ppvnosacv_precnikotvora; // DIRTY
    }
    //
    if (family === 'terkk$ppvnosacv/PLOCICA') { // PLOCICA je materijal
      // item.distinction_key = "terkk$ppvnosacv"; // DIRTY
      /*
      PLOCICA UNP NOSACA VENTILATORA potrebno je staviti kao materijal sa sledećim identom "NVEP2000000" i nazivom "Plocica za fiksiranje nosaca ventilatora P01-10-B-P2"
      Koriste se 4 komada po sklopu.
      // NJ 2024-11-07: Kod pločice treba promeniti količinu na 2 po sklopu.
      */
    }
    //
    //
  }
  // 
  if (povrsina > -1) {
    item.povrsina = terUtilsNumberRoundUp((povrsina / 1000000), 2); // konvertovana u m2 i zaokruzeno na 2 decimale // DIRTY
  }
  if (_cnc) {
    item.cnccrtez = _cnc; // DIRTY
  }
  if (_naziv) {
    item.naziv = _naziv; // DIRTY
  }
  //
  return item;
};


//
export const _derivat_terkk_ppvnosacv_izracunaj_za_step_protobomp = (state, pods_input) => {
  console.log('_derivat_terkk_ppvnosacv_izracunaj_za_step_protobomp state', state);
  //
  const {
    tipkomore,
  } = pods_input;
  const {
    ppv_ventilator_ident,
    ppvnosac_tip,
    // ppv_brojventilatora,
    ppvnosacv_brojventilatoraponosacu,
    ppvnosacv_duzinanosacal,
    ppvnosacv_l1,
    ppvnosacv_l2,
    ppvnosacv_l3,
    ppvnosacv_precnikotvora,
    ppvnosacv_materijal_lim,
    ppvnosacv_materijal_lim_maska_unp,
    ppvnosacv_materijal_profil_unp_bezdimenzioni,
    kolicina,
  } = state;
  //

  let ppvnosacv_unpmaska = "NE";
  if (ppvnosac_tip === "B") { // Nosač tip B kada je vantilator Visina_nosaca === "45"
    // TIP B je UNP profil čelični PROFIL
    if (tipkomore === "HYGIENE:pro") {
      // NJ: maska ide samo u slucjau kada je komora higijenik i kada ima UNP profil. Maska ide preko ump profila pa da se zastiti taj deo da bude maska od prohroma.
      ppvnosacv_unpmaska = "DA";
    }
  }


  // TODO
  const protobomp_superdata = {
    ppv_ventilator_ident,
    ppvnosacv_brojventilatoraponosacu,
    ppvnosacv_duzinanosacal,
    ppvnosacv_l1,
    ppvnosacv_l2,
    ppvnosacv_l3,
    ppvnosacv_precnikotvora,
    ppvnosacv_materijal_lim,
    ppvnosacv_materijal_lim_maska_unp,
    ppvnosacv_materijal_profil_unp_bezdimenzioni,
    ppvnosacv_unpmaska,
  };

  //
  // 
  // let _arr = [];
  let _protobomp = protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$ppvnosacv"), protobomp_superdata);
  //
  //
  const _pbnode_dirty_enrich = _derivat_terkk_ppvnosacv_pbnode_dirty_enrich;
  // ----- kreiranje sklopova
  //
  const _sklop_uzor = {
  };
  let _temp_sklop;
  let _temp_pbnode;
  // preskacemo sklop ovaj put nego cemo ga dodati po potrebi...
  //
  // ----- dodavanje primitivnih u sklopove
  //
  // "LIM_OMEGA_A", "PROFIL_UNP", "MASKA", "PLOCICA"
  if (ppvnosac_tip === "A") {  // Nosač tip A kada je vantilator Visina_nosaca === "30"
    // *1 TIP A je omega LIM operacija savijanja i secenja
    // ako je A tip bude samo jedan element tip A
    if (true) { // 3. Odnosi se na OMEGA profil 
      const item = {
        tempkey: 1,
        pbnode_family: 'terkk$ppvnosacv/LIM_OMEGA_A',
        naziv: '? LIM_OMEGA_A',
        kolicina: kolicina, // Količina: jednaka je količini iz koraka 2
        identmaterijala: ppvnosacv_materijal_lim,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      // protobomp_manipulator.add(_protobomp, pbnode, sklop_nosacv_b);
      protobomp_manipulator.add(_protobomp, pbnode, null);
    }
  }
  if (ppvnosac_tip === "B") { // Nosač tip B kada je vantilator Visina_nosaca === "45"
    // *2 TIP B je UNP profil čelični PROFIL
    //
    _temp_sklop = {
      ..._sklop_uzor,
      pbnode_family: 'terkk$ppvnosacv/SKLOP_B',
      naziv: '* ? SKLOP NOSAC VENTILATORA B',
      kolicina: kolicina, // Količina: jednaka je količini iz koraka 2
    };
    _pbnode_dirty_enrich(_temp_sklop, protobomp_superdata, true);
    _temp_pbnode = terProtobompUtils_pbnode_entity_create_ASSEMBLY_TER_SKLOP(_temp_sklop, { allow_delete: true }, 'SKLOP_NOSACV_B');
    const { created_tempkey: sklop_nosacv_b } = protobomp_manipulator.add(_protobomp, _temp_pbnode, null);
    //
    if (true) { // 1. odnosi se na UNP profil
      const item = {
        // tempkey: 1,
        pbnode_family: 'terkk$ppvnosacv/PROFIL_UNP_B', // Čelični profil
        naziv: '? PROFIL UNP',
        // kolicina: kolicina, // Količina: jednaka je količini iz koraka 2
        kolicina: 1,
        identmaterijala: ppvnosacv_materijal_profil_unp_bezdimenzioni,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_PROFIL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_nosacv_b);
    }
    // *3
    if (ppvnosacv_unpmaska === "DA") {
      // NJ: maska ide samo u slucjau kada je komora higijenik i kada ima UNP profil. Maska ide preko ump profila pa da se zastiti taj deo da bude maska od prohroma.
      const item = { // 2. Odnosi se na masku UNP profila(ona se pojavljuje samo kada je higijenik komora i imamo UNP profil)
        // tempkey: 1,
        pbnode_family: 'terkk$ppvnosacv/UNP_MASKA',
        naziv: '? MASKA',
        // kolicina: kolicina, // Količina: jednaka je količini iz koraka 2
        kolicina: 1,
        identmaterijala: ppvnosacv_materijal_lim_maska_unp,
      };
      _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_LIM(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_nosacv_b);
    }
    // *4
    if (true) {
      // NJ: Plocica ide uvek ako ima UNP profil, uvek ide 2 komada. A ako nema UNP profil onda ne ide plocica uopse
      // NJ 2024-11-06. Koristićemo pločicu kao materijal (isto kao kod pločica za cevi klizača). PLOCICA UNP NOSACA VENTILATORA
      const item = {
        // tempkey: 140,
        pbnode_family: 'terkk$ppvnosacv/PLOCICA',
        naziv: "Plocica za fiksiranje nosaca ventilatora P01-10-B-P2",
        // kolicina: 4, // NJ 2024-11-06: Koriste se 4 komada po sklopu.
        kolicina: 2, // NJ 2024-11-07: Kod pločice treba promeniti količinu na 2 po sklopu.
        jm: tclocal.JM_KOM,
        terkategorija: "M",
        identcustom: "NVEP2000000",
      };
      // _pbnode_dirty_enrich(item, protobomp_superdata, true);
      const pbnode = terProtobompUtils_pbnode_entity_create_PRIMITIVE_TER_MATERIJAL(item);
      protobomp_manipulator.add(_protobomp, pbnode, sklop_nosacv_b);
    }
  }
  //
  //
  return {
    // _arr,
    _protobomp,
  };
};


// ---------- VIRBOM DERIVATS ----------


export const derAutoCreateVirbom_terkk_ppv_prepare_vir_input = (p) => {
  // TODO
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const v_input = {
    p: { ...p },
  };
  delete v_input.p.virtelschemakey;
  delete v_input.p.virtelclass;
  delete v_input.p.tergrupa;
  delete v_input.p.subkey;
  delete v_input.p.parent_subkey;
  return v_input;
};


export const derAutoCreateVirbom_terkk_ppv_children = (v_input, _unbundled_subDraftel_arr) => {
  console.log('derAutoCreateVirbom_terkk_ppv_children(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // PETLJA---------
  let _counterSubdraftelArrItem = 0;
  console.log(typeof _unbundled_subDraftel_arr);
  console.log(Array.isArray(_unbundled_subDraftel_arr));
  console.log(_unbundled_subDraftel_arr);
  _unbundled_subDraftel_arr.forEach((subDraftel) => {
    // EACH
    _counterSubdraftelArrItem++;
    let _derkey = 'der_virtel_child_' + _counterSubdraftelArrItem;


    // derivat EACH local 1
    // S4+P4 operacija 2.
    _derivat_key = _derkey;
    const _params = {
      // "virtelclass": "terkk$ppv$sekcija",
      /*
      "virtelclass": "terkk$ppv$sekcija_opsav",
      "terkategorija": "PP",
      "tergrupa": "LIM",
      "operacija": "OPSEC",
      "rc": "RCLINS4P4",
      "angazovanihradnika": 1,
      "vremepripreme": 0,
      "vremeoperacije": 0,
      "vremeugradnje": 0,
      "jm": "kom",
      */
      //
      // termaterijal: "LB00000J",
    };
    if (subDraftel.tip !== "PPV_DODATNI_MATERIJAL") {

      x = {
        // ...v_input.p, // ceo ppv explodiran
        _derivat_key,
        virtelschemakey: 'terkk$ppv$sekcija',
        tip: subDraftel.tip, // tip sekcije
        // ppv_tip, // 1D 4D ...
        naziv: subDraftel.naziv,
        sirina: subDraftel.sirina,
        visina: subDraftel.visina,
        povrsina: subDraftel.povrsina,
        ppv_oznaka: subDraftel.ppv_oznaka,
        ppv_4dstrana: subDraftel.ppv_4dstrana,
        ppv_medjuspoj_top: subDraftel.ppv_medjuspoj_top,
        ppv_medjuspoj_bottom: subDraftel.ppv_medjuspoj_bottom,
        ppv_medjuspoj_left: subDraftel.ppv_medjuspoj_left,
        ppv_medjuspoj_right: subDraftel.ppv_medjuspoj_right,
        ppv_bezotvora: subDraftel.ppv_bezotvora, //
        //
        ppv_isojacanjaposirini: v_input.p.ppv_isojacanjaposirini, // v_input
        ppv_isojacanjapovisini: v_input.p.ppv_isojacanjapovisini, // v_input
        //
        ppv_b: v_input.p.ppv_b, // v_input
        ppv_b1: v_input.p.ppv_b1, // v_input
        ppv_b2: v_input.p.ppv_b2, // v_input
        ppv_b3: v_input.p.ppv_b3, // v_input
        ppv_b4: v_input.p.ppv_b4, // v_input
        ppv_h: v_input.p.ppv_h, // v_input
        ppv_h1: v_input.p.ppv_h1, // v_input
        ppv_h2: v_input.p.ppv_h2, // v_input
        ppv_h3: v_input.p.ppv_h3, // v_input
        ppv_h4: v_input.p.ppv_h4, // v_input
        //
        ppv_o1: v_input.p.ppv_o1, // v_input
        ppv_o1zazor: v_input.p.ppv_o1zazor, // v_input
        ppv_o2: v_input.p.ppv_o2, // v_input
        ppv_kolikootvorazaelv: v_input.p.ppv_kolikootvorazaelv, // v_input
        //
        cncprogram1: subDraftel.cncprogram1,
        multitranslator_lang: subDraftel.lang, // NOVO
        kolicina: subDraftel.kolicina,
        termaterijal: v_input.p.termaterijal,
        //
        // ovi mozda ne trebaju
        ppv_dodatakzasavijanje: v_input.p.ppv_dodatakzasavijanje, // v_input
        ppv_sirinaojacanja: v_input.p.ppv_sirinaojacanja, // v_input
        ppv_ventilator_ident: v_input.p.ppv_ventilator_ident, // v_input
        //
        ..._params,
        // ..._getParamsFromLib("terkk$ppv$sekcija"),
        ..._getParamsFromLib("terkk$ppv$sekcija_opsav"),
      }; // parametri na kraju imaju prioritet
      x._materijal_naziv = x.naziv + '_m ???';
      z[_derivat_key] = x;
      _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);

      // S4+P4 operacija 1.
      x = {
        ...x,
        virtelclass: "terkk$ppv$sekcija_opsec",
        kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // po komadu sledece operacije
        ..._getParamsFromLib("terkk$ppv$sekcija_opsec"),
      };
      _virbom_manipulator.add_as_last_virtel_children(virbom_ref, x);


      // derivat EACH local 1.1
      _derivat_key = _derivat_key + '_m';
      // _mat = _derivat_modulprofil_materijal1_by_pp(xx);
      const _materijal_ident = x.termaterijal; // TODO
      // const _materijal_naziv = x._materijal_naziv;
      const _materijal_naziv = _getFromLibMaterijalLimSingleParam(_materijal_ident, "naziv"); //
      const _kolicina = x.povrsina; //
      const _params_m = {
        "virtelclass": "terkk$materijal_lim",
        "terkategorija": "M",
        "tergrupa": "LIM",
        "jm": "m2",
      };
      xm = {
        naziv: _materijal_naziv,
        calculated_ident: _materijal_ident,
        custom_ident: _materijal_ident,
        terkategorija: 'M',
        kolicina: _kolicina, // ???
        jm: tclocal.JM_M2,
        //
        _derivat_key,
        // virtelschemakey: 'terkk$ppv$sekcija$materijal1'
        virtelschemakey: "terkk$materijal_lim",
        // virtelschemakey: "terkk$materijal_lim",
        virtelclass: "terkk$materijal_lim",
        ..._params_m,
        // ..._getParamsFromLib("terkk$materijal_lim"),
      }; // parametri na kraju imaju prioritet
      z[_derivat_key] = xm;
      _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);

    } else if (subDraftel.tip === "PPV_DODATNI_MATERIJAL") { // SKIP IN THIS FUNCTION 
      // SKIP IN THIS FUNCTION
    }


  });  // end of PETLJA----------
  //


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


export const derAutoCreateVirbom_terkk_ppv_children_special_for_parent = (v_input, _unbundled_subDraftel_arr) => {
  console.log('derAutoCreateVirbom_terkk_ppv_children_special_for_parent(v_input) ');
  console.log(v_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // PETLJA---------
  let _counterSubdraftelArrItem = 0;
  console.log(typeof _unbundled_subDraftel_arr);
  console.log(Array.isArray(_unbundled_subDraftel_arr));
  console.log(_unbundled_subDraftel_arr);
  _unbundled_subDraftel_arr.forEach((subDraftel) => {
    // EACH
    _counterSubdraftelArrItem++;
    let _derkey = 'der_virtel_child_' + _counterSubdraftelArrItem;


    // derivat EACH local 1
    _derivat_key = _derkey;
    if (subDraftel.tip !== "PPV_DODATNI_MATERIJAL") { // SKIP IN THIS FUNCTION
      // SKIP IN THIS FUNCTION
    } else if (subDraftel.tip === "PPV_DODATNI_MATERIJAL") { //   
      //
      _derivat_key = _derivat_key + '_m';
      /*
      // _mat = _derivat_modulprofil_materijal1_by_pp(xx);
      const _materijal_ident = x.termaterijal; // TODO
      // const _materijal_naziv = x._materijal_naziv;
      const _materijal_naziv = _getFromLibMaterijalLimSingleParam(_materijal_ident, "naziv"); //
      */
      //
      /*
      ppv_servisni_prekidac_ident: null,
      ppv_servisni_prekidac_naziv: null,
      // ppv_servisni_prekidac_kolicina: null,
      kolicina
      */
      const formState = {
        identcustom: subDraftel.identmaterijala,
        naziv: subDraftel.naziv_materijala,
        kolicina: subDraftel.kolicina,
      };
      const _params_m = {
        virtelschemakey: 'terkk$materijalcustom',
        "virtelclass": 'terkk$materijalcustom',
        "terkategorija": "M",
        // "tergrupa": "LIM",
        "jm": "kom",
      };
      xm = {
        ...formState,
        ..._params_m,
        // ..._getParamsFromLib("terkk$materijal_lim"),
      }; // parametri na kraju imaju prioritet
      if (xm.kolicina > 0) {
        z[_derivat_key] = xm;
        // _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);
        _virbom_manipulator.add_on_top_graphlevel(virbom_ref, xm);
      }
      //
    }


  });  // end of PETLJA----------
  //


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};

